import React from 'react';
import { useParams } from 'react-router-dom';
import AssistenteFinanceiro from '../components/AssistenteFinanceiro';

/**
 * Página dedicada do Assistente Financeiro (tela cheia).
 * A mesma experiência da bolha, acessível pelo menu lateral.
 */
export default function AssistenteFinanceiroCliente() {
  const { cliente_id } = useParams();
  return <AssistenteFinanceiro clienteId={cliente_id} modo="pagina" />;
}
